import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
export function UrgencyBar() {
  // Set initial time to 2 hours (7200 seconds)
  const [timeLeft, setTimeLeft] = useState(7200);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="fixed top-0 left-0 right-0 z-50 bg-coral-dark text-white shadow-md" data-id="element-189">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-6 text-sm sm:text-base font-medium text-center" data-id="element-190">
        <p className="flex-1 sm:flex-none" data-id="element-191">
          <span className="font-bold text-gold" data-id="element-192">LIMITED TIME OFFER:</span> Get
          the Woman 90 Protocol for just $6.39 (Save 97%!).
        </p>
        <div className="flex items-center gap-2 bg-white/20 px-3 py-1 rounded-full whitespace-nowrap" data-id="element-193">
          <span className="relative flex h-3 w-3" data-id="element-194">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-195"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-white" data-id="element-196"></span>
          </span>
          <Timer className="w-4 h-4" data-id="element-197" />
          <span className="font-bold font-heading tracking-wider" data-id="element-198">
            {formatTime(timeLeft)}
          </span>
        </div>
      </div>
    </div>;
}